/**
 *
 * @param {Array<Number>} array
 * @returns
 */
const getEqualArrayItems = (array) => {
  return array.every((value) => value === array[0]);
};

export default getEqualArrayItems;
